import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { CountryLegacy, CountryLegacyService } from '@adeo/ngx-kozikaza-api/misc/country-legacy';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-kaza-edit-country',
  templateUrl: './kaza-edit-country.component.html'
})
@AutoUnsubscribe([])
export class KazaEditCountryComponent extends OnDestroyComponent implements OnInit {
  @Input() kazaForm: UntypedFormGroup;
  @Input() country: string;
  @Input() submitted: boolean;

  countries: Array<CountryLegacy>;
  private subscriptionCountryGet: Subscription;

  constructor(
      private countryLegacyService: CountryLegacyService,
      private toastr: ToastrService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.loadCountries();
  }

  initForm(): void {
    this.kazaForm.addControl('country', new UntypedFormControl(this.country, Validators.required));
  }

  loadCountries(): void {
    this.subscriptionCountryGet = this.countryLegacyService.getCountries().pipe(
        catchError(err => {
          this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
          return throwError(err);
        }),
        tap(data => this.countries = data as Array<CountryLegacy>)
    ).subscribe();
  }
}
